/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesStatsMonthlyShippedResponse } from '../../models/sales-stats-monthly-shipped-response';

export interface GetSalesStatsMonthlyShipped$Params {
  productCategoryIds: Array<number>;
  customerIds: Array<number>;
  agentIds: Array<number>;
  dateFrom?: string;
  dateTo?: string;
  isFullMonth?: boolean;
}

export function getSalesStatsMonthlyShipped(http: HttpClient, rootUrl: string, params: GetSalesStatsMonthlyShipped$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsMonthlyShippedResponse>> {
  const rb = new RequestBuilder(rootUrl, getSalesStatsMonthlyShipped.PATH, 'get');
  if (params) {
    rb.query('productCategoryIds', params.productCategoryIds, {});
    rb.query('customerIds', params.customerIds, {});
    rb.query('agentIds', params.agentIds, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('isFullMonth', params.isFullMonth, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SalesStatsMonthlyShippedResponse>;
    })
  );
}

getSalesStatsMonthlyShipped.PATH = '/sales-stats/monthly-shipped';
